/**
 * Tiny dependency-free SVG sparkline.
 * Responsive: fills its parent's width via SVG viewBox; height stays fixed.
 * - `data`: number[] (>=2 points recommended)
 * - `color`: stroke color
 * - `height`: pixel height (default 60)
 */
const Sparkline = ({ data = [], color = '#335CFF', height = 60, strokeWidth = 2 }) => {
  // Internal coordinate system; SVG scales to parent width via viewBox.
  const VBW = 300;
  if (!data || data.length === 0) {
    return <svg width="100%" height={height} className="block" preserveAspectRatio="none" />;
  }
  const max = Math.max(...data, 1);
  const min = Math.min(...data, 0);
  const span = max - min || 1;
  // Inset stroke so caps don't clip at the card edge.
  const padX = 2;
  const padY = strokeWidth;
  const innerW = VBW - padX * 2;
  const innerH = height - padY * 2;
  const stepX = data.length > 1 ? innerW / (data.length - 1) : 0;
  const points = data.map((v, i) => {
    const x = padX + i * stepX;
    const y = padY + innerH - ((v - min) / span) * innerH;
    return `${x.toFixed(1)},${y.toFixed(1)}`;
  });
  const path = `M ${points.join(' L ')}`;
  const areaPath = `${path} L ${VBW - padX},${height - padY} L ${padX},${height - padY} Z`;
  return (
    <svg
      width="100%"
      height={height}
      viewBox={`0 0 ${VBW} ${height}`}
      className="block"
      preserveAspectRatio="none"
    >
      <path d={areaPath} fill={color} opacity="0.12" />
      <path
        d={path}
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
};

export default Sparkline;
